import {
    temAcesso
} from '@/shared/auth/temAcesso'
const Comissionamentos = () => import('./Comissionamentos.vue')
export default {
    path: 'comissionamento',
    name: 'Contratos_Comissionamentos',
    component: Comissionamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-COMISSIONAMENTOS-00')) {
            next()
        }
    },

}
